import Vue from 'vue';

const numberWithCommas = (x) => {
  return x.toString().replace(/\B(?=(\d{3})+(?!\d))/g, " ");
};

Vue.filter('money', (value) => {
  if (value === 0) {
    return 0;
  }
  if (!value) {
    return '';
  }
  return numberWithCommas(value);
});
